import { Injectable } from '@angular/core';
import { BaseAuthenticatedService } from './base-authenticated.service';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { Observable } from 'rxjs';
import {
  httpQueryParams,
  PaginatedResponse,
} from './base-authenticated.service';
import { FiscalEventInterface } from '@app/interface/fiscal-event';
import { ActivatedRoute } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class FiscalEventApi extends BaseAuthenticatedService {
  constructor(
    public override auth: AngularFireAuth,
    public override httpClient: HttpClient, // private cookieService: CookieService
    private route: ActivatedRoute, // Inject ActivatedRoute
  ) {
    super(auth, httpClient);
  }

  public getEventList<T = FiscalEventInterface>(
    organization_id: string | null,
    params: httpQueryParams = {},
  ): Observable<PaginatedResponse<T>> {
    if (!organization_id) {
      throw new Error('Organization ID is required');
    }
    let path = `api/${organization_id}/fiscal-event/`;
    return this.getList<T>(path, params);
  }

  public createFiscalEvent(
    organization_id: number | null,
    fiscalEventData: Partial<FiscalEventInterface>,
  ): Observable<FiscalEventInterface> {
    console.log('id:', organization_id);
    const path = `api/${organization_id}/fiscal-event/`;

    return this.post<FiscalEventInterface>(path, {}, fiscalEventData);
  }

  public updateFiscalEventDetails(
    organization_id: number | null,
    id: number,
    data: Partial<FiscalEventInterface>,
  ): Observable<FiscalEventInterface> {
    return this.partialUpdate<FiscalEventInterface>(
      `api/${organization_id}/fiscal-event/${id}/`,
      {}, //{ withCredentials: true },
      data,
    );
  }
}
